import {
  createFormField,
  FormFieldBlueprint,
} from '@backstage/plugin-scaffolder-react/alpha';
import { EntityPickerWithDefaults } from './function';

export const EntityPickerWithDefaultsFormField = FormFieldBlueprint.make({
  name: 'entity-picker-with-defaults',
  params: {
    field: async () =>
      createFormField({
        name: 'EntityPickerWithDefaults',
        component: EntityPickerWithDefaults,
      }),
  },
});
